exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".showRightPanel {\n  overflow: hidden;\n  position: relative;\n  width: calc(100% - 0.078125rem);\n}", ""]);

// exports
